import { createSlice } from "@reduxjs/toolkit";

function formAdd() {
    return {        
        isOpen: false,
        edit: false,
        nome: "",
        arquivo: null,
        erro : "",
        processando : false,
    }
}

function formAgendar() {
    return  {
        isOpen : false,
        error : "",
        processando : false,
        periodicidade : "",
        scriptId : "",
    }
}

const initialState = {
    disponibilidade: "loading",
    lista: [],
    formAdd: formAdd(),
    execucoes : {
        carregando : false,
        solicitando : false,
        baixandoLog : false,
        lista: [],
        logData : null,
        modalOpen : false,
    },
    agendamentos : {
        carregando : false,
        lista: [],
        form : formAgendar()
    }
}

export const scriptSlice = createSlice({
    name: "script",
    initialState,
    reducers: {
        triggerVerificaDisponibilidadeServidorRunner: () => { },
        toggleAddScript : (state) => {
            state.formAdd = {
                ...state.formAdd,
                isOpen : !state.formAdd.isOpen,
                edit: false,
            }
        },
        setDisponibildade: (state, action) => {
            state.disponibilidade = action.payload
        },
        updateFormAddAttr: (state, action) => {
            state.formAdd[action.payload.campo] = action.payload.value
        },
        triggerFormAddProcessar : () => {},
        triggerFormEdicaoProcessar : () => {},
        clearFormAdd : (state) => {
            state.formAdd = formAdd()
        },
        triggerCarregaListaScripts : () => {},
        setListaScripts : (state, action) => {
            state.lista = action.payload
        },
        triggerDeletarScript: () => {},
        toggleEditScript : (state, action) => {

            var n = state.lista.filter( (e) => e.id == action.payload)[0]

            state.formAdd = {
                ...state.formAdd,
                isOpen : !state.formAdd.isOpen,
                nome: n.nome,
                edit : action.payload
            }
        },
        triggerFormEdicaoProcessar : () => {},
        triggerCarregaListaExecucoes : () => {},
        updateExecucoesAtributo : (state, action) => {
            state.execucoes[action.payload.campo] = action.payload.value 
        },
        triggerSolicitaExecucao: () => {},
        triggerBaixaLog : () => {},
        triggerCarregaScriptAgendamentos : () => {},
        updateAgendamentosAtributo : (state, action) => {
            state.agendamentos[action.payload.campo] = action.payload.value 
        },
        triggerRemoverAgendamento : () => {},
        updateAgendamentosFormAtributo : (state, action) => {
            state.agendamentos.form[action.payload.campo] = action.payload.value
        },
        resetarAgendamentosForm : (state) => {
            state.agendamentos.form = formAgendar()
        },
        triggerAgendarScript : () => {},
        triggerBaixarScript: () => {}
    }
})

export const {
    triggerVerificaDisponibilidadeServidorRunner,
    setDisponibildade,
    toggleAddScript,
    updateFormAddAttr,
    triggerFormAddProcessar,
    clearFormAdd,
    triggerCarregaListaScripts,
    setListaScripts,
    triggerDeletarScript,
    toggleEditScript,
    triggerFormEdicaoProcessar,
    triggerCarregaListaExecucoes,
    updateExecucoesAtributo,
    triggerSolicitaExecucao,
    triggerBaixaLog,
    triggerCarregaScriptAgendamentos,
    updateAgendamentosAtributo,
    triggerRemoverAgendamento,
    updateAgendamentosFormAtributo,
    resetarAgendamentosForm,
    triggerAgendarScript,
    triggerBaixarScript
    
} = scriptSlice.actions;

export default scriptSlice.reducer;